'use client'

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { User, LogOut } from 'lucide-react'
import { usePlayerAuth } from '../_auth/player-auth-provider'

export function PlayerUserMenu() {
  const { user, signOut } = usePlayerAuth()

  if (!user) return null

  const initial = (user.name || user.email || '?').slice(0, 1).toUpperCase()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="rounded-full h-8 w-8 p-0">
          <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-muted text-xs font-medium">
            {initial}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="flex flex-col">
            <span className="text-sm font-medium">{user.name || 'Player'}</span>
            {user.email && <span className="text-xs text-muted-foreground">{user.email}</span>}
            {user.isAnonymous && <span className="text-xs text-muted-foreground">Demo mode</span>}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={signOut}>
          <LogOut className="h-4 w-4 mr-2" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
